import Konva from 'konva';
import {SHAPE_ENUMS} from '../enums';

export const initializeKonvaStage = (container, width, height, options) => {
  return new Konva.Stage({
    container: container,
    width: width,
    height: height,
    ...options
  });
};

export const initializeKonvaLayer = options => {
  return new Konva.Layer({
    ...options
  });
};

export const drawShape = (shape, w, h) => {
  if (!shape) return;

  const data = getShapeDataBasedOnContainer(shape, w, h);

  switch (shape.shape) {
    case SHAPE_ENUMS.ARROW:
      return drawArrow(shape, data);
    case SHAPE_ENUMS.RECT:
      return drawRect(shape, data);
    case SHAPE_ENUMS.LINE:
      return drawLine(shape, data);
    case SHAPE_ENUMS.ELLIPSE:
      return drawEllipse(shape, data);
  }
};

export const drawArrow = (shape, data) => {
  const {id, color, thickness} = shape;
  const {startX, startY, endX, endY} = data;

  return new Konva.Arrow({
    id,
    points: [startX, startY, endX, endY],
    stroke: color,
    fill: color,
    strokeWidth: thickness
  });
};

export const drawRect = (shape, data) => {
  const {id, color, thickness} = shape;
  const {x, y, width, height} = data;

  return new Konva.Rect({
    id,
    x,
    y,
    width,
    height,
    stroke: color,
    strokeWidth: thickness
  });
};

export const drawLine = (shape, data) => {
  const {id, color, thickness} = shape;
  const {startX, startY, endX, endY} = data;

  return new Konva.Line({
    id,
    points: [startX, startY, endX, endY],
    stroke: color,
    strokeWidth: thickness,
    lineCap: 'round',
    lineJoin: 'round'
  });
};

export const drawEllipse = (shape, data) => {
  const {id, color, thickness} = shape;
  const {x, y, radiusX, radiusY} = data;

  return new Konva.Ellipse({
    id,
    x,
    y,
    radiusX,
    radiusY,
    stroke: color,
    strokeWidth: thickness
  });
};

export const getShapeDataBasedOnContainer = (shape, w, h) => {
  const {data} = shape;

  switch (shape.shape) {
    case SHAPE_ENUMS.ARROW:
      return {
        startX: data.startX * w,
        startY: data.startY * h,
        endX: data.endX * w,
        endY: data.endY * h
      };
    case SHAPE_ENUMS.RECT:
      return {
        x: data.x * w,
        y: data.y * h,
        width: data.width * w,
        height: data.height * h
      };
    case SHAPE_ENUMS.LINE:
      return {
        startX: data.startX * w,
        startY: data.startY * h,
        endX: data.endX * w,
        endY: data.endY * h
      };
    case SHAPE_ENUMS.ELLIPSE:
      return {
        x: data.x * w,
        y: data.y * h,
        radiusX: data.radiusX * w,
        radiusY: data.radiusY * h
      };
  }
};

export const extraHitSelection = 30;
